import { lazy } from "react";
import { lazyRetry } from "../../../helpers";

export default lazy(() =>
  lazyRetry(() => import("./ActivateAccount"), "activate-account-page")
);
